import { FederationType } from '@nebulr-group/nblocks-react/lib/utils/AuthService';
import { decode } from 'js-base64';

/** Standard interfaces when interacting with Cloud views */
export type CloudViewsFlow =
    | 'openidconnect'
    | 'openidconnect_signup'
    | 'full'
    | 'ms-azure-marketplace-landing-page'
    | 'user-management-portal'
    | 'user-management-users'
    | 'user-management-workspace'
    | 'user-management-profile'
    | 'select-plan';

export class CloudViewsHandoverArgs {
    entryPoint?: string;
    code?: string;
    redirectUri?: string;
    errorDetails?: {
        type: 'AUTHENTICATION_ERROR' | 'SIGNUP_ERROR' | 'FEDERATION_MISSING_USER' | 'MAGIC_LINK_EXPIRED';
        federation?: FederationType
    };
    signupOptions?: {
        signupPlan?: string;
        signupCurrency?: string;
        signupRecurrenceInterval?: string;
    }
}

/**
 * Example input
 * appId=633402fdf28d8e00252948b1&flow=full&args=eyJlbnRyeVBvaW50IjoiL2F1dGgvc2V0LXBhc3N3b3JkLzEyMzQ1NjcifQ==
 * 
 */
export class HandoverUtil {
    static resolve(searchPath: string): {
        args: CloudViewsHandoverArgs;
        flow: CloudViewsFlow;
        appId: string | null;
    } {
        const urlSearch = new URLSearchParams(searchPath);
        // Allows to grab the app id
        const appId = urlSearch.get('appId');
        // Argument can be used to know how far the user will go before it will be redirectes back to another ui
        const flow = urlSearch.get('flow') as CloudViewsFlow;
        // Unserialize the object of config telling the UI what view to render first.
        // Base64 of json object like { entrypoint: '/auth/login' }
        const argsStr = decode(urlSearch.get('args') ?? '');
        const args = (argsStr.length > 0 ? JSON.parse(argsStr) : {}) as CloudViewsHandoverArgs;

        return { args, flow, appId };
    }
}